export const getTimeRemaining = (endtime) => {
  const t = Date.parse(endtime) - Date.parse(new Date());
  const seconds = Math.floor((t / 1000) % 60);
  const minutes = Math.floor((t / 1000 / 60) % 60);
  const hours = Math.floor((t / (1000 * 60 * 60)) % 24);
  const days = Math.floor(t / (1000 * 60 * 60 * 24));

  let dateTime = "";

  if (days > 0) dateTime = `${dateTime}${days}d : `;
  if (hours > 0) dateTime = `${dateTime}${hours}h : `;
  if (minutes > 0) dateTime = `${dateTime}${minutes}m : `;
  if (seconds > 0) dateTime = `${dateTime}${seconds}s`;

  return dateTime;
}
